<template lang="pug">
  #ReservationIndex.container-width
    h5.text-center.pt-2 我的預約
    .button-row.px-5.row.no-gutters.mb-3
      .col-4
        b-button.button-first(
          block,
          :variant=" nowSelect === 'checking' ? 'primary text-white' : 'outline-primary' ",
          @click="changeStatusHandler('checking')"
        ) 確認中
      .col-4
        b-button(
          block,
          :variant=" nowSelect === 'checked' ? 'primary text-white' : 'outline-primary' ",
          @click="changeStatusHandler('checked')"
        ) 已確認
      .col-4
        b-button.button-last(
          block,
          :variant=" nowSelect === 'expired' ? 'primary text-white' : 'outline-primary' ",
          @click="changeStatusHandler('expired')"
        ) 已過期
    .px-3
      b-card.border-0.mb-2.customerCard.overflow-hidden(
        bg-variant="light",
        v-for="(reserve,index) in reservations",
        :key="reserve.reservation_id"
      )
        .row.position-relative.no-gutters(
          :class="{ 'no-gutters': reserve.status === 0, 'align-items-center': reserve.status === 0 }"
        )
          .col-9.pr-1
            p.mb-1.font-weight-bold {{ reserve.reserve_type_name }}
            small.mb-0.d-block 預約時間：{{ reserve.reserve_date }} {{ reserve.start_time }}～{{ reserve.end_time }}
            small.mb-0.d-block 預約門市：{{ reserve.store_name }}
            small.mb-0.d-block 預約顧問：{{ reserve.sa_chinese_last_name }} {{ reserve.sa_chinese_first_name }}
            small.mb-0.d-block 預約狀態：{{ reserve.status === 'checking' ? '確認中' : reserve.status === 'checked' ? '已確認' : reserve.status === 'expired' ? '預約已過期' : '-' }}
          .col-3.pl-1.d-flex.align-items-center.justify-content-center
            .editBtn(
              v-show="reserve.status === 'checking' || reserve.status === 'checked'",
              @click="editReaerveHandler(reserve)"
            )
              b-button.rounded-50.d-flex.align-items-center.justify-content-center.p-1.button(
                variant="primary"
              )
                i.fas.fa-pencil-alt.fa-lg
              small.mb-0.d-block.w-100.text-center 預約修改
          .labelTag(
            v-show="reserve.status === 'expired'"
          )
            span.labelTag__text 已過期
      infinite-loading(
        @infinite="infiniteHandler",
        :identifier="infiniteId",
        spinner="bubbles"
      )
        .cursor-default(slot="no-more") 無更多資料
        .cursor-default(slot="no-results") 無更多資料
        .cursor-default(slot="error") 發生錯誤，請重整重試一次
</template>

<script>
import { mapState } from 'vuex';
import { M_RESERVATION_EDIT } from '@/router/member/reservation';
import InfiniteLoading from 'vue-infinite-loading';

export default {
  name: 'ReservationIndex',
  components: {
    InfiniteLoading
  },
  data() {
    return {
      nowSelect: 'checking',
      infiniteId: +new Date()
    };
  },
  created() {
    const vm = this;
    vm.$swal.fire({
      title: '載入中，請稍候',
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      }
    });
    vm.$store.commit('member_reservation/resetHandler');
    vm.$swal.close();
    vm.$store.commit('toggleLoading', false);
    vm.$store.dispatch('member_reservation/getReservationTimeListHandler');
  },
  methods: {
    infiniteHandler($state) {
      const vm = this;
      vm.$store.dispatch('member_reservation/getReservationHandler', {
        current_page: parseInt(vm.pagination.current_page) + 1,
        per_page: vm.pagination.per_page,
        status: vm.nowSelect
      }).then(() => {
        if (vm.pagination.current_page != vm.pagination.total_page) {
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    changeStatusHandler(type) {
      const vm = this;
      switch (type) {
        case 'checking':
          if (vm.nowSelect === 'checking') return;
          vm.nowSelect = 'checking';
          vm.$store.commit('member_reservation/resetHandler');
          vm.infiniteId += 1;
          break;
        case 'checked':
          if (vm.nowSelect === 'checked') return;
          vm.nowSelect = 'checked';
          vm.$store.commit('member_reservation/resetHandler');
          vm.infiniteId += 1;
          break;
        case 'expired':
          if (vm.nowSelect === 'expired') return;
          vm.nowSelect = 'expired';
          vm.$store.commit('member_reservation/resetHandler');
          vm.infiniteId += 1;
          break;
        default:
          break;
      }
    },
    editReaerveHandler(reservation) {
      const vm = this;
      vm.$router.push({
        name: M_RESERVATION_EDIT,
        params: {
          id: reservation.reservation_id,
          editInfo: reservation
        }
      });
    }
  },
  computed: {
    ...mapState({
      reservations: (state) => state.member_reservation.reservations,
      reservationTimeList: (state) => state.member_reservation.reservationTimeList,
      pagination: (state) => state.member_reservation.pagination
    })
  }
};
</script>

<style>

</style>
